import moment from 'moment';

// 获取 URL 的 query 参数
export function getQueryParamsFromUrl() {
  // 使用 window.location.search 获取 ? 后面的部分（例如 "?code=123&utm_source=666"）
  const queryString = window.location.search;

  if (!queryString) return {};

  // 解析 queryString
  return queryString
    .slice(1) // 去掉开头的 "?" 字符
    .split("&") // 按 "&" 分割每个键值对
    .reduce((params, pair) => {
      const [key, value] = pair.split("=");
      params[key] = decodeURIComponent(value || "");
      return params;
    }, {});
}
//邮箱验证
export function emailVerification(data) {
  let reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(data);
}

//手机号验证
export function phoneVerification(data) {
  let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
  return reg.test(data);
}
//判断数据为空
export function isEmpty(val) {
  if (!val) {
    return false;
  } else if (val == "null") {
    return false;
  } else if (val == "undefined") {
    return false;
  } else return true;
}
//毛毫秒时间格式处理
export function formattedDate(timestamp, formatType) {
  return moment(timestamp).format(formatType); // 使用 moment 的 format 方法进行格式化
}
//防抖
export function debounce(func, delay = 500) {
  let timer;
  return function (...args) {
    const context = this;
    // 清除旧定时器，阻止重复执行
    if (timer) clearTimeout(timer);
    // 设置新定时器，确保最终仅执行最后一次
    timer = setTimeout(() => {
      func.apply(context, args);
      timer = null;
    }, delay);
  };
}
//数字掩码
export function maskID(id) {
  return id.replace(/(\w{4})\w*(\w{4})/, '$1****$2');
}
//金额截取
export function amountFormatter(amount) {
  if (amount) {
    return Number(amount).toFixed(2);
  } else {
    return '0.00'
  }

}
//时间格式处理
export function formatDate(date, format = 'YYYY-MM-DD') {
  return moment(date).format(format);
}
//手机号格式处理
export function formatPhone(phone) {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}
//本地存储获取数据
export function getLocalStorageData(key) {
  return JSON.parse(localStorage.getItem(key));
}
//本地存储设置数据
export function setLocalStorageData(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

/**
 * 解析 yyyy-mm-dd 格式的字符串为 Date 对象
 * @param {string} dateString - 日期字符串，如 '2024-06-15'
 * @returns {Date|null} 解析后的 Date 对象，无效时返回 null
 */
export function parseDateString(dateString) {
  if (!dateString) return null;
  const parts = dateString.split('-');
  if (parts.length !== 3) return null;
  const [year, month, day] = parts.map(part => parseInt(part, 10));
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
  // 注意：Date 构造函数的月份是从 0 开始的，所以需要减去 1
  return new Date(year, month - 1, day);
}
/**
 * 判断当前运行环境是 iOS、Android 还是 PC
 * @returns {'ios' | 'android' | 'pc'} 环境类型字符串
 */
export function getDeviceOS() {
  // 1. 优先使用现代浏览器支持的 userAgentData API
  if (navigator.userAgentData && navigator.userAgentData.platform) {
    const platform = navigator.userAgentData.platform.toLowerCase();
    if (platform.includes('android')) return 'android';
    if (platform.includes('ios') || platform.includes('iphone') || platform.includes('ipad')) return 'ios';
  }
  // 2. 降级使用传统 userAgent 字符串匹配
  const ua = navigator.userAgent;

  // 匹配 Android
  if (/Android|Adr/i.test(ua)) return 'android';

  // 匹配 iOS (iPhone / iPad / iPod)
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';

  // 特殊处理：iPadOS 13及以上版本的 Safari 浏览器默认会伪装成 Mac (PC端)
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';

  // 3. 都不匹配则默认为 PC 或其他环境
  return 'pc';
}
